import {useNavigate, useParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import Meta from "../common/Meta";
import {setAppGuidCookie} from "../common/appCookie";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import CustomerStorePane from "./pane/CustomerStorePane";
import {CompanyContext} from "../../lib/CompanyProvider";
import MDTypography from "../../components/MDTypography";
import {Grid} from "@mui/material";
import CustomerCafePane from "./pane/CustomerCafePane";
import {getPreferenceValue} from "../common/Utils";

export default function CustomerStore(props) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const navigate = useNavigate();
  let {guid} = useParams();
  const [pageReady, setPageReady] = useState(false);

  useEffect(() => {
    if (guid) {
      setAppGuidCookie(guid);
    }
  }, [guid]);

  useEffect(() => {
    if (companyContext?.company?.guid) {
      setPageReady(true);
    }
  }, [companyContext?.company]);


  return (
    <>
      <CustomerPageLayout>
        <Meta pageTitle={props?.cafeMode ? 'Cafe': 'Store'}/>

        <CustomerHeader props={props}/>

        {pageReady && <MDBox>
          <MDBox m={3}>
            <Grid container cols={3} spacing={3} direction="row">
              <Grid item sm={12} xs={12}>
                <h1>
                  {props?.cafeMode && <>
                    {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_cafe', 'Cafe')}
                  </>}
                  {!props?.cafeMode && <>
                    {companyContext?.company?.preferences && getPreferenceValue(companyContext?.company?.preferences, 'menu_item_store', 'Store')}
                  </>}
                </h1>
                {props?.cafeMode && <CustomerCafePane /> }
                {!props?.cafeMode && <CustomerStorePane /> }
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        }

        <Footer/>
      </CustomerPageLayout>
    </>
  )
}